import { instance } from "@/api/index";

function login(param) {
    return instance.post("/auth/login", param);
}

function refresh(param) {
    return instance.get("/auth/refresh", { params: param });
}

function adminLogin(param) {
    return instance.post("/auth/admin-login", param);
}


export { login, refresh, adminLogin };